export default __webpack_public_path__ + "static/media/6.a4efa6b0.webp";